export const ChooseCohesionConfig = {
  fuse: {
    endpoint: 'https://www.chooseenergy.com/fuse',
    leases: [
      {
        pool: 'MfitUsNumeh7eS3jnhYjAe',
        name: 'ES-CHOOSE-FUSE-PERMA-BANNER',
      },
      {
        pool: 'MfitUsNumeh7eS3jnhYjAe',
        name: 'ES-CHOOSE-FUSE-PERMA-GRID',
      },
      {
        pool: 'MfitUsNumeh7eS3jnhYjAe',
        name: 'ES-CHOOSE-FUSE-CONTENT-GRID',
      },
      {
        pool: 'MfitUsNumeh7eS3jnhYjAe',
        name: 'ES-CHOOSE-FUSE-PERMA-CHECKOUT',
      },
    ],
  },
  monarch: {
    autoRequest: {
      enabled: true,
      suppressPlacements: true,
      timeout: 15000,
    },
    sourceId: '6cb2f710-eed9-404d-9b0d-518d8c0894ea',
    token: 'fd0a8b3a-efb9-48ea-9721-ca0892acc10c',
  },
  tagular: {
    apiKey: 'bd979364-baf4-46b0-94d3-c81c42f801eb.5fef3d5d-8af1-43d8-ad2b-8ce03fea0cd6',
    writeKey: 'wk_1NT28wKy3uZCE4KQFF70DT4dHvQ',
    sourceKey: 'src_1NT291E8FqtfGxVJrOY8gv25jek',
    // beamHook: function (event: any) {
    //   window.dataLayer = window.dataLayer || []
    //   window.dataLayer.push({
    //     event: event['@type'],
    //     tagularPayload: event,
    //   })
    // },
    cookieDomain: 'chooseenergy.com',
    domainWhitelist: ['electricrates.chooseenergy.com'],
    apiHost: 'https://www.chooseenergy.com/tagular/v2/t',
  },
}
